import React from 'react'
import loadingImg from '../../styles/images/logo-img.svg'
import loadingBg from '../../styles/images/loading-bg.svg'

const Loading = () => (
  <div className='loading-wrapper'>
    <div className='loading'>
      <div className='loading-img'>
        <img src={loadingImg} className='logo' alt='Loading' />
        <img src={loadingBg} className='animated' alt='Loading' />
      </div>
      <p className='loading-msg'>Loading...</p>
    </div>
  </div>
)

export default Loading



// WEBPACK FOOTER //
// ./src/ui/views/loading.js